import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';
import { TabSettingsWorkspaceWrapper } from '../_base/TabSettingsWorkspaceWrapper';
import ViewWorkspaceInfo from './ViewWorkspaceInfo';

export const TabSettingsWorkspaceGeneralEdit = () => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  return (
    <TabSettingsWorkspaceWrapper type={ESettingsWorkspaceTab.GENERAL} required_owner_access>
      <div className="flex flex-col justify-start items-start mt-2 gap-3 text-page-foreground">
        <span className="text-xl">{t(i18n_page_settings_workspace.tabs.general.title)}</span>
        <ViewWorkspaceInfo />
      </div>
    </TabSettingsWorkspaceWrapper>
  );
};
